module.exports = __webpack_public_path__ + "images/my_medicare_4c2e29d.svg";